const isLocalDev = () =>
  process.env.NEXT_PUBLIC_RETAILER_SELECTOR_MAINTENANCE !== 'true' &&
  typeof window !== 'undefined' &&
  window.location.origin.includes('localhost');

const isAuthoring = () =>
  typeof window !== 'undefined' &&
  new URL(window.location.origin).hostname === 'authoring.volvocars.com';

const isPR = () =>
  typeof window !== 'undefined' &&
  window.location.origin.startsWith('https://pr-');

const isStorybook = () => {
  if (typeof window === 'undefined') return false;
  try {
    const hostname = new URL(window.location.origin).hostname;
    return hostname === 'storybooks.ccdp.io';
  } catch {
    return false;
  }
};

export const getAccessHeader = () => {
  if ((isLocalDev() || isPR()) && process.env.NEXT_PUBLIC_QAWWW_HEADER)
    return {
      QAWWW: process.env.NEXT_PUBLIC_QAWWW_HEADER,
    };
};

const QA_URL = 'https://qawww.volvocars.com';
const PROD_URL = 'https://www.volvocars.com';

export const getOrigin = () => {
  if (isLocalDev() || isPR()) {
    return QA_URL;
  }
  if (isAuthoring() || isStorybook()) {
    return PROD_URL;
  }
  return '';
};

export const fetchFromDealerLocator = async <T, E = object>(
  endpoint: string,
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  params: Record<string, any>,
): Promise<{ data: T; error?: undefined } | { data?: undefined; error: E }> => {
  const origin = getOrigin();
  const queryString = new URLSearchParams(params);

  const url = `${origin}${endpoint}?${queryString}`;

  try {
    const response = await fetch(url, {
      headers: getAccessHeader(),
    });
    if (!response.ok) {
      return {
        error: await response.json(),
      };
    }
    return {
      data: await response.json(),
    };
  } catch (error) {
    return { error: error as E };
  }
};
